import React, { useMemo } from 'react';
import FairyLights from './FairyLights';
import '../../styles/festive.css';

/** Same scene on every render: a small seeded random. */
const seeded = (seed) => () => {
  seed = (seed * 9301 + 49297) % 233280;
  return seed / 233280;
};

/**
 * Christmas night scene behind the dashboard welcome: fairy lights along the top, stars, falling
 * snow, rooftops and a tree. The children sit on top of it.
 */
const NightBanner = ({ children }) => {
  const { stars, flakes } = useMemo(() => {
    const rand = seeded(11);
    return {
      stars: Array.from({ length: 30 }, () => ({ left: rand() * 100, top: 14 + rand() * 44, size: 1 + rand() * 2, delay: -rand() * 3 })),
      flakes: Array.from({ length: 30 }, () => ({
        left: rand() * 100,
        size: 2 + rand() * 3,
        opacity: 0.5 + rand() * 0.5,
        duration: 7 + rand() * 7,
        delay: -rand() * 14,
      })),
    };
  }, []);

  return (
    <section className="night-banner">
      <div className="night-banner__scene" aria-hidden="true">
        {stars.map((s, i) => (
          <span key={`s${i}`} className="night-banner__star" style={{ left: `${s.left}%`, top: `${s.top}%`, width: s.size, height: s.size, animationDelay: `${s.delay}s` }} />
        ))}
        {flakes.map((f, i) => (
          <span
            key={`f${i}`}
            className="night-banner__flake"
            style={{ left: `${f.left}%`, width: f.size, height: f.size, opacity: f.opacity, animationDuration: `${f.duration}s`, animationDelay: `${f.delay}s` }}
          />
        ))}
        <FairyLights className="night-banner__lights" count={24} swags={6} depth={11} />
        <svg className="night-banner__rooftops" viewBox="0 0 1000 110" preserveAspectRatio="xMidYMax slice">
          <path
            fill="#0b1433"
            d="M0 110 V70 H40 V58 H70 V74 H110 V52 H130 V40 H138 V52 H160 V66 H210 V60 H250 V76 H300 V56 H330 V48 H352 V56 H380 V70 H420 V62 H452 V44 Q 470 14 488 44 V30 H494 V22 H500 V30 H506 V44 Q 524 14 542 44 V62 H580 V70 H620 V54 H650 V64 H700 V50 H716 V36 H724 V50 H740 V68 H790 V58 H830 V72 H870 V60 H910 V70 H950 V56 H1000 V110 Z"
          />
          <circle cx="497" cy="18" r="3" fill="#f2c94c" />
        </svg>
        <svg className="night-banner__tree" width="120" height="150" viewBox="0 0 120 150">
          <polygon points="60,8 92,60 76,60 104,104 82,104 112,140 8,140 38,104 16,104 44,60 28,60" fill="#12805c" />
          <rect x="52" y="140" width="16" height="10" fill="#5a3d1e" />
          <polygon points="60,0 63,7 70,7 64,11 66,18 60,14 54,18 56,11 50,7 57,7" fill="#f2c94c" />
          <circle cx="50" cy="56" r="3.5" fill="#e5484d" />
          <circle cx="72" cy="88" r="3.5" fill="#f2c94c" />
          <circle cx="44" cy="98" r="3.5" fill="#6e8cf5" />
          <circle cx="80" cy="126" r="3.5" fill="#e5484d" />
          <circle cx="36" cy="128" r="3.5" fill="#f2c94c" />
        </svg>
      </div>
      <div className="night-banner__content">{children}</div>
    </section>
  );
};

export default NightBanner;
